<div class="modal-body">
    <div *ngIf='addresses'>

        {{addresses.Street1}}<br />
        {{addresses.City}}, {{addresses.State}} {{addresses.PostalCode}}<br />
        {{addresses.County}}<br />
        {{addresses.Country}}
    </div>
</div>
<div class="modal-footer">
    <button name="validButton" #validButton (click)="createAccountValidatedAddress2()"
        class="btn btn-primary btn-main btn-block">{{'validateAddress.modal.buttons.footer.useValidatedAddress' |
        translate}}</button>
    <button name="origButton" #origButton (click)="createAccountOriginalAddress2()"
        class="btn btn-primary btn-main btn-block btn-light">{{'validateAddress.modal.buttons.footer.useEnteredAddress'
        | translate}}</button>
</div>
<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="ball-spin-clockwise" [fullScreen]="true">
    <p style="color: white"> {{'createAccount.spinner.creatingAccount' | translate}}</p>
</ngx-spinner>
<!--<simple-notifications [options]="options"></simple-notifications>-->